var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9985 0.00183201C11.3819 0.00183201 11.732 0.20691 11.8987 0.529957L14.7577 6.04871L21.1467 6.93543C21.5218 6.98621 21.8302 7.2323 21.9511 7.56824C22.0677 7.90808 21.9719 8.27918 21.7052 8.52527L17.0707 12.83L18.1668 18.9042C18.2293 19.2557 18.0751 19.6151 17.7626 19.8221C17.4542 20.0292 17.0082 20.0565 16.7081 19.8886L10.9985 17.0292L5.25543 19.8886C4.95536 20.0565 4.54693 20.0292 4.23435 19.8221C3.92595 19.6151 3.77174 19.2557 3.79675 18.9042L4.92618 12.83L0.296336 8.52527C0.0271054 8.27918 -0.0683338 7.90808 0.0500275 7.56824C0.167972 7.2323 0.479296 6.98621 0.853968 6.93543L7.23923 6.04871L10.0982 0.529957C10.2691 0.206871 10.615 0.00183201 10.9985 0.00183201ZM10.9985 3.08582L8.81044 7.31433C8.66457 7.59168 8.38117 7.78699 8.05609 7.83386L3.12492 8.51355L6.70577 11.8378C6.93499 12.0526 7.03918 12.3612 6.985 12.662L6.14314 17.3339L10.5275 15.1386C10.8234 14.9901 11.1777 14.9901 11.4694 15.1386L15.8538 17.3339L15.0119 12.662C14.9577 12.3612 15.0661 12.0526 15.2953 11.8378L18.8753 8.51355L13.945 7.83386C13.6157 7.78699 13.3323 7.59168 13.1906 7.31433L10.9985 3.08582Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRegular);
export default __webpack_public_path__ + "static/media/star-regular.6a8006f441526f6577f91bf397b57488.svg";
export { ForwardRef as ReactComponent };